import styles from "./styles.module.css";
import Header from "./header";
import Fields from "./fields";
import Security from "./security/index.js";
import Data from "./data";
import Triggers from "./triggers";
import { DatabaseValue } from "../../../contexts/database";
import { UserValue } from "../../../contexts/user";
import { useState, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { renameTable, deleteTable } from "../../../utils/databaseactions";
import { MdClose } from "react-icons/md";
import { useQueryClient } from "react-query";
import Modal from "../../../modal";

export default function Paper({ open, active, setActive }) {
  const [fnIsRunning, setFnIsRunning] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("fields");
  const [newName, setNewName] = useState("");
  const [table, setTable] = useState(0);
  const context = useContext(DatabaseValue);
  const user = useContext(UserValue);
  const queryClient = useQueryClient();
  const { appId } = useParams();

  useEffect(() => {
    setTable(context[active] || null);
  }, [active, context]);

  useEffect(() => {
    if (!!table) {
      setNewName(table.name);
    }
  }, [table]);

  useEffect(() => {
    if (!open) setTable(null);
  }, [open]);

  useEffect(() => {
    if (!modalIsOpen) setFnIsRunning(false);
  }, [modalIsOpen]);

  const cancel = () => {
    setModalIsOpen(false);
  };

  const changeName = () => {
    if (!active || newName === table.name) return;
    renameTable(appId, table.id, newName);
  };

  const handleEnter = (e) => {
    if (e.keyCode === 13 || e.keyCode === 9) {
      changeName();
      e.target.blur();
    }
  };

  const handleDelete = (e) => {
    if (table.id === "user") {
      window.alert("You can't delete this table");
      setModalIsOpen(false);
      return;
    }
    setFnIsRunning(true);
    const action = deleteTable(appId, table.id, user);
    action
      .then(() => {
        setModalIsOpen(false);
        setActive(null);
        queryClient.invalidateQueries("roleData");
      })
      .catch((err) => console.log(err));
  };

  if (!open || !table || table === undefined) return null;
  return (
    <div className={styles.paper}>
      <div
        style={{
          width: "-webkit-fill-available",
          margin: "10px 30px",
        }}
      >
        <div id="PAPERCANVAS" className={styles.paperBody}>
          <div className={styles.title}>
            <input
              className={styles.titleInput}
              value={newName}
              onKeyDown={handleEnter}
              onChange={(e) => setNewName(e.target.value)}
            />
            <div
              className={styles.deleteButton}
              onClick={() => setModalIsOpen(true)}
            >
              Delete
            </div>
          </div>
          <Header title={activeTab} onClick={setActiveTab} />
          <Fields
            open={activeTab === "fields"}
            id={active}
            tableId={table.id}
          />
          <Security open={activeTab === "security"} id={active} />
          <Data open={activeTab === "data"} id={active} tableId={table.id} />
          <Triggers open={activeTab === "triggers"} />
          <Modal onClose={() => setModalIsOpen(false)} open={modalIsOpen}>
            <div className={styles.form}>
              {fnIsRunning ? (
                <div className={styles.formContainer}>
                  <div className={styles.text}>
                    Deleting {table.name || ""} Table
                  </div>
                </div>
              ) : (
                <>
                  <div className={styles.formTitle}>
                    Delete Table <MdClose onClick={cancel} className="icon" />
                  </div>
                  <div className={styles.formContainer}>
                    <div
                      className={styles.text}
                      style={{ textAlign: "center", marginBottom: 15 }}
                    >
                      Are you sure you? This can't be undone...
                    </div>
                    <button className={styles.save} onClick={handleDelete}>
                      Yes, delete {table.name || ""}
                    </button>
                    <button className={styles.clear} onClick={cancel}>
                      Cancel
                    </button>
                  </div>
                </>
              )}
            </div>
          </Modal>
        </div>
      </div>
    </div>
  );
}
